module.exports = __webpack_public_path__ + "img/2300101dcl.26fe13da.png";